export enum LnOrderStatus {
  All = 0,
  Suspended = 2,
  Free = 5,
  InProcess = 20,
  Modified = 25,
  Closed = 30,
  Cancelled = 35,
  Blocked = 40,
  Released = 45
}
